import React, { useEffect, useContext, useState } from 'react';
import Wrapper from './Wrapper';
import { fetchDataAgnostic } from '../../Services/dataApi';
import { useAuth0 } from '../../auth0/reactAuth0Spa.js';
import { DepartmentContext } from '../../DepartmentWrapper';
import { checkLoginForError, formatBearerToken } from '../../Common.functions';
import { EvaluatorPortalStateContext } from './EvaluatorPortalStateContext';

const areInterviewDatesEquivalent = (firstDates = [], secondDates = []) => {
  if (firstDates === secondDates) {
    return true;
  }

  if (!Array.isArray(firstDates) || !Array.isArray(secondDates) || firstDates.length !== secondDates.length) {
    return false;
  }

  return firstDates.every((item, index) => {
    const other = secondDates[index];
    return (
      item &&
      other &&
      item.pk_InterviewDate === other.pk_InterviewDate &&
      item.DateOfInterview === other.DateOfInterview &&
      item.StartTime === other.StartTime
    );
  });
};

const RezRATE = (props) => {
  const { date, match, isAdmin, selectedEvaluator, evaluator, setEvaluatorInterviewDates, isEmbedded } = props;
  const { getTokenSilently, loginWithRedirect } = useAuth0();
  const dContext = useContext(DepartmentContext);
  const evaluatorPortalState = useContext(EvaluatorPortalStateContext);
  const { setDepartment, department, season } = dContext;
  const [enablePrescreenMode, setEnablePrescreenMode] = useState(false);
  const shouldUseLocalEvaluatorPortalState = !isAdmin && !isEmbedded && !!evaluatorPortalState;
  const portalDateArray = evaluatorPortalState ? evaluatorPortalState.dateArray : null;
  const setPortalDateArray = evaluatorPortalState ? evaluatorPortalState.setDateArray : null;

  useEffect(() => {
    const type = 'evaluator';
    if (setDepartment && department && !isAdmin && (!department.roleType || department.roleType !== type)) {
      setDepartment((prevState) => {
        // eslint-disable-next-line
        let clone = structuredClone(prevState);
        clone.roleType = type;
        return clone;
      });
    }
  }, [setDepartment, department]);

  useEffect(() => {
    // if is admin and no evaluator is selected don't make the call
    const isAdminAndNoSelectedEvaluator =
      isAdmin && (!selectedEvaluator || Object.keys(selectedEvaluator).length === 0);
    if (isAdminAndNoSelectedEvaluator || !season) {
      return;
    }

    // setTimeout(() => {
    getTokenSilently()
      .then((token) => {
        fetchDataAgnostic(
          'department/season/evaluator/interviewDates',
          {
            pk_Department: dContext.department.pk_Department,
            pk_Season: dContext.season.pk_Season,
            isAdmin,
            pk_User: selectedEvaluator ? selectedEvaluator.pk_User : null,
          },
          formatBearerToken(token),
        )
          .then((res) => {
            if (shouldUseLocalEvaluatorPortalState && setPortalDateArray) {
              if (!areInterviewDatesEquivalent(portalDateArray, res.data)) {
                setPortalDateArray(res.data);
              }
            } else {
              setEvaluatorInterviewDates(res.data);
            }
          })
          .catch((err) => {});
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
    // }, 15000);
  }, [
    isAdmin,
    selectedEvaluator,
    season,
    shouldUseLocalEvaluatorPortalState,
    portalDateArray,
    setPortalDateArray,
    setEvaluatorInterviewDates,
    getTokenSilently,
    loginWithRedirect,
    dContext.department,
    dContext.season,
  ]);

  return <Wrapper {...props}></Wrapper>;
};

export default RezRATE;
